var map = {
	"./lang-en.json": [
		735,
		31
	],
	"./lang-tr.json": [
		259
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 698;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locale lazy ^\.\/lang\-.*\.json$
// module id = 698
// module chunks = 34